import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
export default {
  name: 'dynamicbagging',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      isLoading: false,
      resultCount: 0,
      hubZone: '',
      hubName: '',
      srcRuleName: '',
      srcClientName: '',
      srcHubName: '',
      srcConnectionName: '',
      srcConnectionNameData: [],
      HubZoneListData: [],
      HubNameData: [],
      DestHubNameData: [],
      allHubMaster: [],
      ClientNameData: [],
      srcRuleNameData: [],
      hubid: '',
      hubZoneObjData: {
        value: "",
        text: ""
      },
      desthubZoneObjData: {
        value: "",
        text: ""
      },
      hubNameObjData: {
        value: "",
        text: ""
      },
      desthubNameObjData: {
        value: "",
        text: ""
      },
      clientNameObjData: {
        value: "",
        text: "",
        detailid: "",
        accountid: ""
      },
      srcRuleNameObjData: {
        value: "",
        text: ""
      },
      srcConnectionObjData: {
        value: "",
        text: "",
        route: ""
      },
      destHubName: '',
      desthubZone: '',
      isZoneError: 0,
      ZoneError: '',
      isHubError: 0,
      HubError: '',
      isDestHubError: 0,
      DestHubError: '',
      isClientError: 0,
      ClientError: '',
      isRuleError: 0,
      RuleError: '',
      isConnectionError: 0,
      ConnectionError: '',
      zoneRight: '',
      clientRight: '',
      ruleRight: '',
      connectionRight: '',
      mappingDetails: [],
      searchConnectionRight: '',
      listSourceHubNameDataObj: {
        text: '',
        value: ''
      },
      listConnectionNameDataObj: {
        text: '',
        value: ''
      },
      listConnectionNameData: [],
      listSourceHubNameData: [],
      searchConnection: '',
      searchHubId: '',
      noConnection: '',
      isClientLoaded: 0,
      clientLoading: 'Please wait.. Client data is loading',
      createdBy: '',
      addmodalshow: false,
      modalShow: false,
      modaldata: '',
      hubLoading: '',
      desthubLoading: '',
      connectionLoading: '',
      clientLoading: '',
      hubzoneLoading: '',
      ruleLoading: '',
      actualRoute: '',
      fltactualRoute: '',
      fltsrcClientName: '',
      fltClientNameData: [],
      fltclientNameObjData: {
        value: "",
        text: "",
        detailid: "",
        accountid: ""
      }
    }
  },

  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;

    this.getHubZone();

    this.getHubClientName();
    this.getSrcRuleName();
    this.getAllHubName()
  },
  created() {
    axios.interceptors.request.use((config) => {
      this.setLoading(true);
      return config;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.setLoading(false);
      return response;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });
  },
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.resultCount++;
        this.isLoading = true;
      } else if (this.resultCount > 0) {
        this.resultCount--;
        this.isLoading = (this.resultCount > 0);
      }
    },
    selectedHubZone(hubData) {
      this.actualRoute = ""
      this.hubZoneObjData = hubData;
      this.hubZone = hubData.value;
      if (this.hubZone == '' || this.hubZone == undefined) {
        this.isZoneError = 1
        this.ZoneError = 'Select Zone'
      } else {
        this.isZoneError = 0;
        this.ZoneError = ''
      }
      this.hubNameObjData = {
        value: "",
        text: ""
      }
      this.desthubNameObjData = {
        value: "",
        text: ""
      }
      this.srcConnectionObjData = {
        value: "",
        text: "",
        route: ""
      }
      this.srcHubName = ''
      this.destHubName = ''
      this.HubNameData = [];
      if (this.hubZone != undefined) {
        this.getHubName();
      }
    },
    selectedDestHubZone(desthubZoneObjData) {
      this.desthubZoneObjData = desthubZoneObjData
      this.desthubZone = desthubZoneObjData.value;
      if (this.desthubZone != undefined) {
        this.getDestHubName();
      }
    },
    selectedHub(hubName) {
      this.actualRoute = ""
      this.hubNameObjData = hubName;
      var a = this.hubNameObjData.value
      // this.DestHubNameData = this.allHubMaster.filter(function(el) {
      // 	return el.value != a
      // });
      this.hubName = hubName.value;
      this.srcHubName = hubName.value
      if (this.srcHubName == '' || this.srcHubName == undefined) {
        this.isHubError = 1
        this.HubError = 'Select Hub'
      } else {
        this.isHubError = 0
        this.HubError = ''
        // this.isConnectionError = 0;
        // this.ConnectionError = ''
      }
      this.srcConnectionObjData = {
        value: "",
        text: "",
        route: ""
      }
      if (this.srcHubName != undefined) {
        this.getConnectionName();
      }
    },
    selectedDestHub(destHub) {
      this.actualRoute = ""
      this.desthubNameObjData = destHub;
      // this.hubName = hubName.value;
      this.destHubName = destHub.value
      if (this.destHubName == '' || this.destHubName == undefined) {
        this.isDestHubError = 1
        this.DestHubError = 'Select Destination Hub'
      } else {
        this.isDestHubError = 0
        this.DestHubError = ''
      }
    },
    selectedClient(clientName) {
      this.clientNameObjData = clientName;
      this.clientName = clientName.value;
      this.srcClientName = clientName.value
      if (this.srcClientName == '' || this.srcClientName == undefined) {
        this.isClientError = 1
        this.ClientError = 'Select Client'
      } else {
        this.isClientError = 0
        this.ClientError = ''
      }
      // this.getSrcRuleName();
    },
    selectedfltClient(fltclientNameObjData) {
      this.fltclientNameObjData = fltclientNameObjData;
      this.fltsrcClientName = fltclientNameObjData.value
      // this.getSrcRuleName();
    },
    selectedRule(ruleName) {
      this.srcRuleNameObjData = ruleName;
      this.ruleName = ruleName.value;
      this.srcRuleName = ruleName.value
      if (this.srcRuleName == '' || this.srcRuleName == undefined) {
        this.isRuleError = 1
        this.RuleError = 'Select Rule'
      } else {
        this.isRuleError = 0
        this.RuleError = ''
      }

    },
    selectedConnection(connectionName) {
      this.srcConnectionObjData = connectionName;
      this.connectionName = connectionName.value;
      this.srcConnectionName = connectionName.value
      this.actualRoute = connectionName.route
      if (this.srcConnectionName == '' || this.srcConnectionName == undefined) {
        this.isConnectionError = 1
        this.ConnectionError = 'Select Connection'
      } else {
        this.isConnectionError = 0
        this.ConnectionError = ''
      }
      //this.getRuleMapping()
    },
    selectedSearchHub(dta) {
      this.listConnectionNameDataObj = {
        text: '',
        value: ''
      }
      this.searchConnection = ''
      this.listSourceHubNameDataObj = dta
      this.searchHubId = dta.value
      this.mappingDetails = []
      this.fltactualRoute = ''
      if (this.searchHubId != undefined) {
        this.getConnectionNameSearch()
      }
    },
    selectedHubConnection(data) {
      this.listConnectionNameDataObj = data
      this.searchConnection = data.value
      this.fltactualRoute = data.filteractualRoute
    },
    //to get hubzone list start
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      this.resultCount = 0;
      this.zoneRight = this.rightLoader
      // this.HubZoneListData=[];
      this.input = ({
        hubName: this.hubzonename,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          self.zoneRight = ''
          //this.HubZoneListData = result.data.data
          var HubZoneListData = result.data.ResponseData;
          for (i = 0; i < HubZoneListData.length; i++) {
            this.HubZoneListData.push({
              value: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
          }
        }, error => {
          self.zoneRight = ''
          console.error(error)
        })
    },
    //to get hubname list start
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.hubZone,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          //this.HubZoneNameData = result.data.data
          var HubNameData = result.data.ResponseData
          var DestHubNameData = []
          for (i = 0; i < HubNameData.length; i++) {
            DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = DestHubNameData
            this.allHubMaster = DestHubNameData
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    getDestHubName() {
      this.desthubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      this.input = ({
        hubZoneId: this.desthubZone,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.desthubLoading = ''
          //this.HubZoneNameData = result.data.data
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    getAllHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          //this.HubZoneNameData = result.data.data
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.listSourceHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    //to get clientname list start
    getHubClientName() {
      this.clientLoading = 'Loading Client...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.resultCount = 0;
      this.input = ({
        BusinessFlow: "Forward",
        BusinessService: "Delivery"
      })
      var self = this
      this.clientRight = this.rightLoader
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'clientbusiness/account/names/flowservice',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.clientLoading = ''
          self.clientRight = ''
          self.isClientLoaded = 1
          self.clientLoading = ''
          //this.HubClientNameData = result.data.data
          //console.log(this.HubClientNameData)

          var ClientNameData = result.data.ResponseData
          for (i = 0; i < ClientNameData.length; i++) {
            this.ClientNameData.push({
              value: ClientNameData[i].ClientMasterID,
              text: ClientNameData[i].clientaccountnamealise,
              detailid: ClientNameData[i].ClientBusinessDetailID,
              accountid: ClientNameData[i].ClientBusinessAccountId
            })
            this.fltClientNameData.push({
              value: ClientNameData[i].ClientMasterID,
              text: ClientNameData[i].clientaccountnamealise,
              detailid: ClientNameData[i].ClientBusinessDetailID,
              accountid: ClientNameData[i].ClientBusinessAccountId
            })
          }
        }, error => {
          self.clientRight = ''
          console.error(error)
        })
    },
    //to get source rule
    getSrcRuleName() {
      this.ruleLoading = 'Loading Rule...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      this.resultCount = 0;
      this.ruleRight = this.rightLoader
      this.input = ({

      })
      axios({
          method: 'GET',
          'url': apiUrl.allocateRuleapi_url + 'fetchShipmentRules',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.ruleLoading = ''
          self.ruleRight = ''
          var srcRuleNameData = result.data.ResponseData
          for (i = 0; i < srcRuleNameData.length; i++) {
            this.srcRuleNameData.push({
              value: srcRuleNameData[i].ruleid,
              text: srcRuleNameData[i].rulename
            })
          }
        }, error => {
          self.ruleRight = ''
          console.error(error)
        })
    },
    //to get connection
    getConnectionName() {
      this.connectionLoading = 'Loading Connection...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      self.srcConnectionNameData = []
      this.resultCount = 0;
      this.input = {
        source: parseInt(self.hubNameObjData.value)
      }
      self.isLoading = true
      self.connectionRight = this.rightLoader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.connectionLoading = ''
          self.connectionRight = ''
          self.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.srcConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName,
                route: srcConnectionNameData[i].FullConnectionName
              })
            }
          } else {
            self.isConnectionError = 1;
            self.ConnectionError = 'No Connection Found'
          }
        }, error => {
          self.connectionRight = ''
          self.isLoading = false
          self.connectionLoading = ''
          self.isConnectionError = 0;
          self.ConnectionError = ''
          //this.$alertify.error('error in connection api')
          this.$alert('error in connection api', "", "error");
          console.error(error)

        })
    },

    getConnectionNameSearch() {
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var self = this
      self.noConnection = ''
      self.listConnectionNameData = []
      this.resultCount = 0;
      this.input = {
        source: parseInt(self.listSourceHubNameDataObj.value)
      }
      self.isLoading = true
      self.searchConnectionRight = this.rightLoader
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          self.searchConnectionRight = ''
          self.isLoading = false
          if (result.data.ResultCode == 100) {
            var srcConnectionNameData = result.data.ResponseData
            for (i = 0; i < srcConnectionNameData.length; i++) {
              this.listConnectionNameData.push({
                value: srcConnectionNameData[i].ConnectionID,
                text: srcConnectionNameData[i].ConnectionName,
                filteractualRoute: srcConnectionNameData[i].FullConnectionName
              })
            }
          } else {
            self.noConnection = 'No Connection Found'
          }
        }, error => {
          self.searchConnectionRight = ''
          self.isLoading = false
					self.noConnection = ''
          //this.$alertify.error('error in connection api')
          this.$alert('error in connection api', "", "error");
          console.error(error)

        })
    },

    //to reset search form
    resetForm() {
      this.isLoading = false
      this.hubZone = ''
      this.hubName = ''
      this.srcRuleName = ''
      this.srcClientName = ''
      this.srcHubName = ''
      this.srcConnectionName = ''
      this.hubid = ''
      this.hubZoneObjData = {
        value: "",
        text: ""
      }
      this.hubNameObjData = {
        value: "",
        text: ""
      }
      this.desthubNameObjData = {
        value: "",
        text: ""
      }
      this.clientNameObjData = {
        value: "",
        text: "",
        detailid: "",
        accountid: ""
      }
      this.srcRuleNameObjData = {
        value: "",
        text: ""
      }
      this.srcConnectionObjData = {
        value: "",
        text: "",
        route: ""
      }
      this.desthubZoneObjData = {
        value: '',
        text: ''
      }
      this.destHubName = ''
      this.desthubLoading = ''
      this.isZoneError = 0
      this.ZoneError = ''
      this.isHubError = 0
      this.HubError = ''
      this.isDestHubError = 0
      this.DestHubError = ''
      this.isClientError = 0
      this.ClientError = ''
      this.isRuleError = 0
      this.RuleError = ''
      this.actualRoute = ''
      this.isConnectionError = 0
      this.ConnectionError = ''
      this.srcConnectionNameData = []
    },
    resetSearchForm() {
      this.hubZone = '';
      this.srcHubName = '';
      this.srcClientName = '';
      this.srcRuleName = '';
      this.srcConnectionName = '';
    },

    //validate all form fields on onsubmit()
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    checkFormError() {
      var isError = 0
      if (this.hubZone == '' || this.hubZone == undefined) {
        this.isZoneError = 1
        this.ZoneError = 'Select Zone'
        isError = 1
      } else {
        this.isZoneError = 0
        this.ZoneError = ''
      }
      if (this.srcHubName == '' || this.srcHubName == undefined) {
        this.isHubError = 1
        this.HubError = 'Select Hub'
        isError = 1
      } else {
        this.isHubError = 0
        this.HubError = ''
      }
      if (this.destHubName == '' || this.destHubName == undefined) {
        this.isDestHubError = 1
        this.DestHubError = 'Select Destination Hub'
        isError = 1
      } else {
        this.isDestHubError = 0
        this.DestHubError = ''
      }
      if (this.srcClientName == '' || this.srcClientName == undefined) {
        this.isClientError = 1
        this.ClientError = 'Select Client'
        isError = 1
      } else {
        this.isClientError = 0
        this.ClientError = ''
      }
      if (this.srcRuleName == '' || this.srcRuleName == undefined) {
        this.isRuleError = 1
        this.RuleError = 'Select Rule'
        isError = 1
      } else {
        this.isRuleError = 0
        this.RuleError = ''
      }
      if (this.srcConnectionName == '' || this.srcConnectionName == undefined) {
        this.isConnectionError = 1
        this.ConnectionError = 'Select Connection'
        isError = 1
      } else {
        this.isConnectionError = 0
        this.ConnectionError = ''
      }
      return isError;
    },
    saveBaggingRole() {
      if (this.checkFormError()) {
        console.log('InValid');
        return false;
      }
      var self = this
      var input = {
        //"csrId": self.hubZone,
        "connectionId": self.srcConnectionName,
        "sourceHubId": self.srcHubName,
        "destinationHubId": self.destHubName,
        "clientId": self.srcClientName,
        "clientBusinessDetailId": Number(self.clientNameObjData.detailid),
        "clientBusinessAccountId": Number(self.clientNameObjData.accountid),
        "ruleId": self.srcRuleName,
        "createdBy": self.createdBy
      }
      // console.log(input);			return false;
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'allocateConnectionwiseClientRuleMapping',
          data: input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(response => {
          self.isLoading = false
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "success");
            self.resetForm()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "error");
          }
        }, error => {
          //	this.$alertify.error('Save API Error')
          this.$alert('Save API Error', "", "error");
          self.isLoading = false
          console.error(error)
        })
    },
    getRuleMapping() {
      var self = this
      this.mappingDetails = []
      if (this.searchConnection != '' && this.searchHubId != '' && this.fltsrcClientName != '' && this.searchConnection != undefined && this.searchHubId != undefined && this.fltsrcClientName != undefined) {
        self.isLoading = true
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + 'fetchConnectionwiseClientRuleMapping?connectionId=' + this.searchConnection + '&sourceHubId=' + this.searchHubId + '&clientBusinessAccountId=' + this.fltclientNameObjData.accountid,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then((response) => {
            self.isLoading = false
            if (response.data.ResultCode == 100) {
              var data = response.data.ResponseData
              if (data.length > 0) {
                for (var x = 0; x < data.length; x++) {
                  var ruleAr = self.srcRuleNameData.filter(obj => obj.value == data[x].ruleid)
                  var rulename = ruleAr.length > 0 ? ruleAr[0].text : '--'
                  var clientAr = self.ClientNameData.filter(obj => obj.accountid == data[x].clientbusinessaccountid)
                  var clientname = clientAr.length > 0 ? clientAr[0].text : '--'
                  var destAr = self.listSourceHubNameData.filter(obj => obj.value == data[x].destinationhubid)
                  var destname = destAr.length > 0 ? destAr[0].text : '--'
                  data[x].clientname = clientname
                  data[x].rulename = rulename
                  data[x].destname = destname
                  this.mappingDetails.push(data[x])
                }
              }
            } else {
              //this.$alertify.error(response.data.ReturnMessage)
              this.$alert(response.data.ReturnMessage, "", "error");
            }
          })
          .catch((httpException) => {
            self.isLoading = false
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    openStatusModal(data) {
      this.modaldata = data
      this.modalShow = true
    },
    closeStatusModal() {
      this.modalShow = false
    },
    activeInactive() {
      var olddata = this.modaldata
      var newactStatus = this.modaldata.isactive ? false : true
      var url = 'deAllocateConnectionwiseClientRuleMapping'
      this.input = {
        "sourceHubId": this.modaldata.sourcehubid,
        "connectionId": this.modaldata.connectionid,
        "destinationHubId": this.modaldata.destinationhubid,
        "clientId": this.modaldata.clientid,
        "clientBusinessAccountId": this.modaldata.clientbusinessaccountid,
        "createdBy": this.modaldata.createdby,
        "isActive": newactStatus
      }
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + url,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          // self.isLoading=false
          // self.lodingAllocatedHubs=''
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "success");
            this.getRuleMapping()
          } else {
            //	this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    }

  },
}



// WEBPACK FOOTER //
// ./src/views/components/DynamicBagging/dynamic_bagging.component.js